import analytics from 'client/analytics';

import { ANALYTICS_EVENT_EXTERNAL_AGENT_TOUR_REQUESTED } from 'client/analytics/eventList';
import { SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL } from 'api/actionTypes';

export default async function sendTourRequestEmail({ state, apiClient }, { listingId }) {
  return apiClient.postWithState({
    state: state,
    action: SR_API_ACTION_SEND_TOUR_REQUEST_EMAIL,
    payload: {
      listingId: listingId,
    },
    onSuccess: (buyersSideTourRequest) => {
      analytics.track(ANALYTICS_EVENT_EXTERNAL_AGENT_TOUR_REQUESTED, {
        listingId: listingId,
      });
      state.set(['buyersSideTourRequests', 'byListingAndUserId'], {
        [`${buyersSideTourRequest.listingId}-${buyersSideTourRequest.userId}`]: buyersSideTourRequest,
      });
    },
  });
}
